/* Florage Korbfueller, Stand 07.10.2026 (Quelle je Position als _fl_quelle).
   Zeigt auf Produktseite, im Warenkorb-Drawer und auf der Warenkorbseite drei
   kleine Pflanzen, die ins selbe Paket passen, mit einem Klick zum Dazulegen.
   Grund: Koerbe mit einer Pflanze um 20 EUR brechen beim Versand von 8,90 EUR
   ab; ab drei Pflanzen gibt es 10 % und Gratisversand. Jede Pflanze aus der
   Liste bringt im bestehenden Paket rund 11 bis 18 EUR Zusatz-Deckungsbeitrag,
   weil Pick und Pack sowie Versand nicht erneut anfallen.
   Liste: ~/florage-korbfueller-2026-10-04/korbfueller_liste.json
   Ruecknahme: Skript- und CSS-Zeile in layout/theme.liquid entfernen. */
(function(){
  var KANDIDATEN = [
    ["alocasia-polly","55950929690964"],["scindapsus-njoy","55950653194580"],
    ["maranta-leuconeura-kerchoveana","51594020553044"],["peperomia-obtipan","51593907667284"],
    ["philodendron-scandens","55937196917076"],["epipremnum-happy-leaf","51594060595540"],
    ["asparagus-setaceus","55962429325652"],["coffea-arabica","55938429649236"],
    ["monstera-monkey-leaf","55923425608020"],["philodendron-selloum-atom","51593989292372"],
    ["begonia-maculata","51593978773844"],["senecio-herreianus","55967365431636"],
    ["pilea-peperomioides","55940042162516"],["sansevieria-laurentii","55943767294292"],
    ["nephrolepis-boston-green-moment-20cm","52703749112148"],["peperomia-rotundifolia","55923431473492"]
  ];
  var MENGE_ZIEL = 3, ANZAHL = 3, CACHE = "fl_kf_v1", CACHE_MS = 30 * 60 * 1000;

  // Gleiche Ausnahmeliste wie fl-freeship.js: laufen als Plant, sind aber Sets.
  var SETS_ALS_PFLANZE = {
    11983857942868: 1, 11983858008404: 1, 11983858106708: 1, 11983858401620: 1,
    11983857975636: 1, 11984233267540: 1, 11984233922900: 1, 11984231891284: 1,
    15481101189460: 1, 15481101222228: 1, 15481105678676: 1
  };

  var produkte = null, korb = null, timer = null, laeuft = false, beobachter = null;
  var aufWarenkorbseite = document.body.classList.contains("template-cart");

  function euro(cent){ return (cent / 100).toFixed(2).replace(".", ",") + " €"; }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }
  function aktuellerHandle(){ var m = location.pathname.match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : null; }

  // Reihenfolge je Sitzung einmal mischen, damit nicht alle dieselben drei sehen.
  function reihenfolge(){
    var key = "fl_kf_ord", ord = null;
    try { ord = JSON.parse(sessionStorage.getItem(key)); } catch(e){}
    if(!ord || ord.length !== KANDIDATEN.length){
      ord = KANDIDATEN.map(function(_, i){ return i; });
      for(var i = ord.length - 1; i > 0; i--){ var j = Math.floor(Math.random() * (i + 1)); var t = ord[i]; ord[i] = ord[j]; ord[j] = t; }
      try { sessionStorage.setItem(key, JSON.stringify(ord)); } catch(e){}
    }
    return ord.map(function(i){ return KANDIDATEN[i]; });
  }

  function ladeProdukte(){
    if(produkte) return Promise.resolve(produkte);
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE));
      if(c && Date.now() - c.ts < CACHE_MS){ produkte = c.d; return Promise.resolve(produkte); }
    } catch(e){}
    return Promise.all(KANDIDATEN.map(function(k){
      return fetch("/products/" + k[0] + ".js").then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
        if(!p) return null;
        var v = (p.variants || []).filter(function(x){ return String(x.id) === k[1]; })[0];
        if(!v || !v.available) return null;
        var img = (v.featured_image && v.featured_image.src) || p.featured_image || "";
        if(img){ img = img.replace(/^\/\//, "https://"); img += (img.indexOf("?") > -1 ? "&" : "?") + "width=180"; }
        return { h: k[0], v: k[1], t: p.title, p: v.price, img: img, url: p.url + "?variant=" + k[1] };
      }).catch(function(){ return null; });
    })).then(function(liste){
      var d = {};
      liste.forEach(function(x){ if(x) d[x.h] = x; });
      produkte = d;
      try { sessionStorage.setItem(CACHE, JSON.stringify({ ts: Date.now(), d: d })); } catch(e){}
      return d;
    });
  }

  function ladeKorb(){
    return fetch("/cart.js", { credentials: "same-origin" }).then(function(r){ return r.json(); }).then(function(c){
      var pflanzen = 0, handles = {};
      (c.items || []).forEach(function(it){
        handles[it.handle] = 1;
        if(it.product_type === "Plant" && !SETS_ALS_PFLANZE[it.product_id]) pflanzen += it.quantity;
      });
      korb = { pflanzen: pflanzen, handles: handles, anzahl: c.item_count || 0 };
      return korb;
    });
  }

  function ueberschrift(ort){
    var n = korb.pflanzen;
    var h = aktuellerHandle();
    // Auf der Produktseite zaehlt die gerade angesehene Pflanze schon mit. Die
    // Formulierung sagt das ausdruecklich, weil der Versandkasten darueber nur
    // den Korb zaehlt und sonst eine andere Zahl zu stehen scheint.
    var mitDieser = ort === "pdp" && h && !korb.handles[h];
    if(mitDieser) n += 1;
    var rest = Math.max(0, MENGE_ZIEL - n);
    if(rest === 0) return { t: "Das passt noch ins Paket", s: "Ohne zusätzliche Versandkosten" };
    // Einzahl und Mehrzahl: "fehlt noch 1 Pflanze", "fehlen noch 2 Pflanzen".
    var menge = rest + (rest === 1 ? " Pflanze" : " Pflanzen");
    var verb = rest === 1 ? "fehlt" : "fehlen";
    return {
      t: mitDieser ? "Mit dieser Pflanze " + verb + " noch " + menge : "Noch " + menge + " dazu",
      s: "Ab 3 Pflanzen: 10 % Rabatt und Versand frei"
    };
  }

  function auswahl(){
    var h = aktuellerHandle(), out = [];
    reihenfolge().forEach(function(k){
      var p = produkte[k[0]];
      if(out.length >= ANZAHL || !p) return;
      if(korb.handles[k[0]] || k[0] === h) return;
      out.push(p);
    });
    return out;
  }

  function baue(ort){
    var liste = auswahl();
    if(!liste.length) return null;
    var k = ueberschrift(ort);
    var el = document.createElement("div");
    el.className = "fl-kf fl-kf--" + ort;
    el.setAttribute("data-fl-kf", ort);
    var html = '<div class="fl-kf__head"><span class="fl-kf__t">' + esc(k.t) + '</span><span class="fl-kf__s">' + esc(k.s) + '</span></div><div class="fl-kf__list">';
    liste.forEach(function(p){
      // Eigener Handler an allen Orten, damit jede Position die Quelle als
      // unsichtbare Eigenschaft traegt und in der Bestellung messbar ist.
      var attr = 'data-kf-add data-kf-ort="' + ort + '"';
      html += '<div class="fl-kf__card">'
        + '<a class="fl-kf__img" href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.t) + '" width="90" height="90" loading="lazy">' : '') + '</a>'
        + '<a class="fl-kf__name" href="' + esc(p.url) + '">' + esc(p.t) + '</a>'
        + '<span class="fl-kf__price">' + euro(p.p) + '</span>'
        + '<button type="button" class="fl-kf__add" ' + attr + ' data-variant-id="' + esc(p.v) + '">+ Dazu</button>'
        + '</div>';
    });
    el.innerHTML = html + '</div>';
    return el;
  }

  function anker(){
    var a = [];
    var buy = document.querySelector(".fl-buy__cart");
    if(buy) a.push({ ort: "pdp", nach: buy });
    var drawer = document.querySelector("[data-cart-drawer] .fl-cd__scroll");
    if(drawer){
      var items = drawer.querySelectorAll("[data-cart-item]");
      if(items.length) a.push({ ort: "drawer", nach: items[items.length - 1] });
    }
    var cp = document.querySelector(".fl-cp-items");
    if(cp && cp.querySelector(".fl-cp-item")) a.push({ ort: "cart", nach: cp });
    return a;
  }

  function zeichne(){
    if(laeuft) return;
    laeuft = true;
    Promise.all([ladeProdukte(), ladeKorb()]).then(function(){
      anker().forEach(function(z){
        var alt = document.querySelector('[data-fl-kf="' + z.ort + '"]');
        var neu = baue(z.ort);
        if(alt) alt.parentNode.removeChild(alt);
        if(neu) z.nach.parentNode.insertBefore(neu, z.nach.nextSibling);
      });
    }).catch(function(){}).then(function(){ laeuft = false; });
  }

  function spaeter(ms){ clearTimeout(timer); timer = setTimeout(zeichne, ms || 600); }

  function fehlt(){
    return anker().some(function(z){ return !document.querySelector('[data-fl-kf="' + z.ort + '"]'); });
  }

  function start(){
    zeichne();
    if(window.MutationObserver && !beobachter){
      // Der Drawer wird nach jeder Korbaenderung komplett neu gerendert.
      beobachter = new MutationObserver(function(){ if(!laeuft && fehlt()) spaeter(250); });
      beobachter.observe(document.body, { childList: true, subtree: true });
    }
  }

  document.addEventListener("click", function(e){
    var t = e.target;
    if(!t || !t.closest) return;
    var eigen = t.closest("[data-kf-add]");
    if(eigen){
      e.preventDefault();
      e.stopPropagation();
      eigen.disabled = true;
      eigen.textContent = "…";
      var ort = eigen.getAttribute("data-kf-ort") || "unbekannt";
      // _fl_quelle beginnt mit Unterstrich: im Checkout unsichtbar, in der
      // Bestellung im Admin und per API lesbar.
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(eigen.getAttribute("data-variant-id")), quantity: 1, properties: { _fl_quelle: "korbfueller-" + ort } }] }) })
        .then(function(r){ if(!r.ok) throw new Error("add " + r.status); })
        .then(function(){
          if(aufWarenkorbseite){ location.reload(); return; }
          return fetch("/cart.js").then(function(r){ return r.json(); }).then(function(c){
            // Zaehler wie global.js setzen, dann ueber den vorhandenen
            // Warenkorb-Knopf Drawer neu rendern und oeffnen lassen.
            document.querySelectorAll("[data-cart-count]").forEach(function(el){
              el.textContent = c.item_count;
              if(c.item_count > 0) el.removeAttribute("hidden"); else el.setAttribute("hidden", "");
            });
            var knopf = document.querySelector("[data-cart-toggle]");
            if(knopf) knopf.click();
            // Signal an fl-freeship.js, damit der Versandbalken den neuen Korb zeigt.
            document.dispatchEvent(new CustomEvent("fl:korb-geaendert"));
            eigen.textContent = "Im Korb";
            spaeter(900);
          });
        })
        .catch(function(){ eigen.disabled = false; eigen.textContent = "+ Dazu"; });
      return;
    }
    if(t.closest(".fl-kf__add, .fl-buy__cart, .fl-btn, [data-remove], [data-qty-up], [data-qty-down], .fl-cd-item__rm")) spaeter(900);
  }, true);

  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
  window.addEventListener("pageshow", function(e){ if(e.persisted) spaeter(100); });
})();
